import React, { useEffect, useState } from "react";
import { Card, CardContent, Box, Button, Tabs, Tab } from "@mui/material";
import * as services from "./../../services/customer";
import * as localServices from "./../../services/local";
import toast, { Toaster } from "react-hot-toast";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import PersonalInfoForm from "./personal_Info_form";
import PaymentInfoForm from "./persnal_payment_form";

import { useNavigate, useSearchParams } from "react-router-dom";

const CustomerForm = () => {
  const [group, setGroup] = useState("");
  const [personType, setPersonType] = useState("normal");
  // const [cars, setCars] = useState([{ type: "", license: "", province: "" }]);
  const [cars, setCars] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    citizenId: "",
    phone: "",
    address: "",
    img: "",
  });
  const [searchParams] = useSearchParams();

  const customer_id = searchParams.get("customer_id");
  const navigate = useNavigate();

  useEffect(() => {
    fetchGroup();
  }, []);

  const fetchGroup = async () => {
    try {
      let res = await services.getGroup();
      const rawData = res.data?.data || [];
      const mapped = rawData.map((group, index) => ({
        id: group.id,
        name: group.name || "-",
      }));
      setCustomerGroups(mapped);

      let resCus = await services.getCustomersById(customer_id);
      const c = resCus?.data?.data;

      setFormData(c);
      setGroup(c.customerGroupId);
      setCars(c.cars);
      setDrivers(c.drivers);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };
  const readCard = async () => {
    try {
      const res = await localServices.readCard();
      let data = res.data.data;
      setFormData({
        ...formData,
        name: data.firstNameTH + " " + data.lastNameTH,
        dob: data.birthday,
        citizenId: data.citizenId,
        address: data.address,
        img: data.photo,
      });

      console.log("ข้อมูลบัตร:", res.data);
    } catch (err) {
      console.error("err:", err);
      alert("ไม่สามารถอ่านบัตรได้");
    }
  };
  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleGroupChange = (event) => {
    setGroup(event.target.value);
  };

  const handleAddCar = () => {
    setCars([...cars, { type: "", license: "", province: "" }]);
  };

  const handleAddDriver = () => {
    setDrivers([...drivers, { name: "", suername: "", idCard: "" }]);
  };

  const handleDeleteCar = (index) => {
    setCars(cars.filter((_, i) => i !== index));
  };

  const handleDeleteDriver = (index) => {
    setDrivers(drivers.filter((_, i) => i !== index));
  };

  const handleCarChange = (index, field, value) => {
    const updatedCars = [...cars];
    updatedCars[index][field] = value;
    setCars(updatedCars);
  };

  const handleDriverChange = (index, field, value) => {
    const updatedDrivers = [...drivers];
    updatedDrivers[index][field] = value;
    setDrivers(updatedDrivers);
  };

  const handleSubmit = async () => {
    try {
      if (formData.img && isBase64(formData.img)) {
        const blob = base64ToBlob(formData.img);
        const form = new FormData();
        form.append("file", blob, "image.png");
        let response = await services.upload(form);
        console.log("response from upload:", response.data);
        formData.img = response.data.file;
      } else {
        formData.img = "";
      }

      const cleanedFormData = Object.fromEntries(
        Object.entries(formData).filter(
          ([_, v]) => v !== null && v !== undefined && v !== ""
        )
      );

      const payload = {
        ...cleanedFormData,
        personType,
        cars,
        drivers,
        customerGroupId: group,
      };

      await services.updateCustomer(payload, customer_id);
      toast.success("แก้ไขรายการสำเร็จ!");
      fetchGroup();
    } catch (err) {
      toast.error("เพิ่มรายการไม่สำเร็จ!");
      console.error("Error creating product:", err);
    }
  };
  function isBase64(str) {
    return (
      typeof str === "string" && /^data:image\/[a-zA-Z]+;base64,/.test(str)
    );
  }
  function base64ToBlob(base64, mimeType = "image/png") {
    const byteString = atob(base64.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeType });
  }
  const handleTabChange = (_, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box p={2}>
      <AppBreadcrumbs />
      <Toaster position="bottom-right" reverseOrder={false} />

      <Box sx={{ maxWidth: 1000, mx: "auto", mt: 4 }}>
        <Card sx={{ mb: 4 }}>
          <CardContent>
            <Tabs value={tabIndex} onChange={handleTabChange} centered>
              <Tab label="ข้อมูลส่วนตัว" />
              <Tab label="การชำระเงิน" />
            </Tabs>

            {tabIndex === 0 && (
              <Box sx={{ mt: 2 }}>
                <PersonalInfoForm
                  formData={formData}
                  handleChange={handleChange}
                  readCard={readCard}
                  customerGroups={customerGroups}
                  group={group}
                  setGroup={setGroup}
                  personType={personType}
                  setPersonType={setPersonType}
                  cars={cars}
                  drivers={drivers}
                  handleAddCar={handleAddCar}
                  handleAddDriver={handleAddDriver}
                  handleDeleteCar={handleDeleteCar}
                  handleDeleteDriver={handleDeleteDriver}
                  handleCarChange={handleCarChange}
                  handleDriverChange={handleDriverChange}
                  // handleSubmit={handleSubmit}
                />
              </Box>
            )}

            {tabIndex === 1 && (
              <Box sx={{ mt: 2 }}>
                <PaymentInfoForm
                  formData={formData}
                  handleChange={handleChange}
                  readCard={readCard}
                  customerGroups={customerGroups}
                  group={group}
                  setGroup={setGroup}
                  personType={personType}
                  setPersonType={setPersonType}
                  cars={cars}
                  handleAddCar={handleAddCar}
                  handleDeleteCar={handleDeleteCar}
                  handleCarChange={handleCarChange}
                  // handleSubmit={handleSubmit}
                />
              </Box>
            )}
            <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                บันทึกข้อมูล
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default CustomerForm;
